import React from "react";
import useAuth from "../Hooks/useAuth";
import ConfirmationModal from "./ConfirmationModal";

const BlogCard = ({ values, i, onDelete }) => {
  const { auth } = useAuth();

  // css style for paragraph of blog to show only fixed lines followed by ellipsis
  const contentStyles = {
    maxHeight: "6em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "4",
    WebkitBoxOrient: "vertical",
  };

  const activateModal = (id) => {
    //activates the modal form to delete blog
    document.getElementById(`confirmationModal${id}-btn-trigger`).click();
  };

  return (
    <div className="card text-bg-light mb-4" key={i}>
      <div className="row flex-row-reverse g-0 mt-1">
        <div className="col-md-4 m-auto text-center">
          <img
            src={values?.blog_image || ""}
            className="img-fluid rounded"
            width={220}
            height={250}
            alt="doctor"
          />
        </div>
        <div className="col-md-8">
          <div className="card-body">
            <div className="d-flex card-title">
              <h4 className="text-truncate me-1 text-capitalize">
                {values?.title || ""}{" "}
              </h4>
              {values?.author?.user === auth?.user?.id && (
                <a href={`/edit/blog/${values?.id}`}>
                  <button className="btn text-primary mb-1 p-1">
                    <i className="fa-regular fa-pen-to-square"></i>
                  </button>
                </a>
              )}
              {(values?.author?.user === auth?.user?.id ||
                auth?.user?.roles === 0) && (
                <>
                  <button
                    onClick={() => activateModal(values?.id)}
                    className="btn text-danger mb-1 p-1"
                  >
                    <i className="fas fa-trash"></i>
                  </button>

                  <ConfirmationModal
                    button="Delete"
                    target={`confirmationModal${values?.id}`}
                    btnClass="d-none"
                    title="Delete Confirmation"
                    body={`Are you sure you want to delete blog ${values?.title}?`}
                    close="No"
                    save="Yes"
                    onClick={() => onDelete(values?.id)}
                  />
                </>
              )}
            </div>
            <div className="d-flex justify-content-between">
              <p className="card-text mb-1">
                By <strong>Dr. {values?.author.user_detail.name || ""}</strong>
              </p>
              <p className="card-text mb-1 d-inline text-capitalize">
                {values?.category || ""}
              </p>
            </div>

            <p className="card-text mb-1" style={contentStyles}>
              {values?.description || ""}
            </p>
            <div className="d-flex justify-content-between">
              <label className="card-text d-inline">
                Posted On:{" "}
                {new Date(values?.posted_date).toLocaleDateString() || ""}
              </label>
              <a href={`/blogs/read/${values?.id}`} className="btn btn-primary">
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
